import { useEffect, useState } from "react";
import SiteHeader from "@/pages/home/components/SiteHeader";
import HeroGrid from "@/pages/home/components/HeroGrid";
import RankingList from "@/pages/home/components/RankingList";
import NameDirectory from "@/pages/home/components/NameDirectory";
import CollectionGrid from "@/pages/home/components/CollectionGrid";
import YearTimeline from "@/pages/home/components/YearTimeline";
import CommentWall from "@/pages/home/components/CommentWall";
import SubscribeSection from "@/pages/home/components/SubscribeSection";
import SiteFooter from "@/pages/home/components/SiteFooter";

function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      aria-label="回到顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="fixed bottom-6 right-6 z-40 flex h-11 w-11 cursor-pointer items-center justify-center rounded-full bg-primary-500 text-background-50 transition-colors hover:bg-primary-600"
    >
      <i className="ri-arrow-up-line text-lg" />
    </button>
  );
}

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <SiteHeader />
      <main className="w-full">
        <HeroGrid />
        <RankingList />
        <NameDirectory />
        <CollectionGrid />
        <YearTimeline />
        <CommentWall />
        <SubscribeSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}